<template>
  <div class="q-col-gutter-sm">
    <div v-if="maritalDependency && !scopeHideElements('hideMaritalDependency', 'modules.member.setup')" class="col-12">
      <q-field hide-bottom-space stack-label dense outlined :label="$t('members.information.spouseElkenMember')">
        <template slot="control">
          <q-option-group
            v-model="memberData.information.spouse.spouse_elken_member"
            :disable="lockMemberData"
            inline
            color="secondary"
            type="radio"
            :options="[
              { label: 'Yes', value: 1 },
              { label: 'No', value: 0 },
            ]"
          />
        </template>
      </q-field>
    </div>
    <div
      v-if="
        (maritalDependency && memberData.information.spouse.spouse_elken_member) ||
          (maritalDependency && scopeHideElements('hideMaritalDependency', 'modules.member.setup'))
      "
      class="col-12 marital-status-dependency"
    >
      <div class="row q-col-gutter-sm">
        <div class="col-12">
          <q-input
            v-model="memberData.information.spouse.spouse_name"
            :class="!scopeHideElements('hideMaritalDependency', 'modules.member.setup') ? 'required' : ''"
            hide-bottom-space
            dense
            outlined
            :label="$t('members.information.spouseName')"
            :error="validation.information.spouse.spouse_name.$error"
            :disable="lockMemberData"
          />
        </div>
        <div class="col-12">
          <q-input
            v-model="memberData.information.spouse.spouse_ibo_id"
            :class="!scopeHideElements('hideMaritalDependency', 'modules.member.setup') ? 'required' : ''"
            hide-bottom-space
            dense
            outlined
            :label="$t('members.information.spouseIboId')"
            :error="validation.information.spouse.spouse_ibo_id.$error"
            :disable="lockMemberData"
          />
        </div>
        <div class="col-12">
          <div class="row q-col-gutter-sm">
            <div class="col-6">
              <q-select
                v-model="memberData.information.spouse.ic_pass_type_id"
                :class="!scopeHideElements('hideMaritalDependency', 'modules.member.setup') ? 'required' : ''"
                hide-bottom-space
                :label="$t('members.icPassportSpouseType.label')"
                :error="
                  validation.information.spouse.ic_pass_type_id.$error ||
                    validation.information.spouse.ic_pass_type_number.$error
                "
                options-dense
                dense
                emit-value
                map-options
                outlined
                clearable
                :disable="lockMemberData"
                :options="masterDataOptionsCreator('ic_passport_type')"
              />
            </div>
            <div class="col-6">
              <q-input
                v-model="memberData.information.spouse.ic_pass_type_number"
                :class="!scopeHideElements('hideMaritalDependency', 'modules.member.setup') ? 'required' : ''"
                hide-bottom-space
                :label="$t('members.icPassportSpouse.label')"
                :error="
                  validation.information.spouse.ic_pass_type_id.$error ||
                    validation.information.spouse.ic_pass_type_number.$error
                "
                dense
                outlined
                :disable="lockMemberData || memberData.information.spouse.ic_pass_type_id === ''"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="maritalDependency && scopeHideElements('hideMaritalDependency', 'modules.member.setup')" class="q-mt-sm">
      <info :message="$t('modules.members.maritalDisclaimerText')"></info>
    </div>
  </div>
</template>

<script>
import { MasterDataTransformarMixin } from 'src/application/global/mixins/index'
import { ScopeConfigMixin } from 'src/application/global/mixins'

export default {
  name: 'MemberMaritalStatus',
  mixins: [MasterDataTransformarMixin, ScopeConfigMixin],
  props: {
    memberData: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    lockMemberData: {
      type: Boolean,
      default: false,
    },
    maritalDependency: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
